// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navDescLarge---laVJs {
  margin: -40px auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 71px 36px 255px;
}
.navDescSmall---wG5we {
  align-items: center;
  justify-content: space-between;
  display: flex;
  width: 100%;
  padding-left: 9px;
  padding-right: 9px;
  margin: 0 auto;
  width: 937px;
}
.description---SAzOh {
  font-family: Arial;
  color: #757575;
  line-height: 19px;
}
.descriptionLarge---HcIHo {
  font-family: Arial;
  color: #757575;
  line-height: 19px;
  max-height: 60px;
  font-size: 16px;
}
.descriptionSmall---gVpo3 {
  font-family: Arial;
  color: #757575;
  line-height: 19px;
  margin: 10px 0;
  font-size: 13px;
  letter-spacing: -0.37px;
  max-height: 40px;
}
@media (max-width: 991.98px) {
  .navDescSmall---wG5we {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/page_description.less"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,4BAAA;AACF;AAEA;EACE,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AAAF;AAGA;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;AADF;AAIA;EALE,kBAAA;EACA,cAAA;EACA,iBAAA;EAKA,gBAAA;EACA,eAAA;AAAF;AAGA;EAXE,kBAAA;EACA,cAAA;EACA,iBAAA;EAWA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;AACF;AAGA;EACE;IACE,WAAA;EADF;AACF","sourcesContent":[".navDescLarge {\n  margin: -40px auto 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 71px 36px 255px;\n}\n\n.navDescSmall {\n  align-items: center;\n  justify-content: space-between;\n  display: flex;\n  width: 100%;\n  padding-left: 9px;\n  padding-right: 9px;\n  margin: 0 auto;\n  width: 937px;\n}\n\n.description {\n  font-family: Arial;\n  color: #757575;\n  line-height: 19px;\n}\n\n.descriptionLarge {\n  .description;\n  max-height: 60px;\n  font-size: 16px;\n}\n\n.descriptionSmall {\n  .description;\n  margin: 10px 0;\n  font-size: 13px;\n  letter-spacing: -0.37px;\n  max-height: 40px;\n}\n\n// Medium devices (tablets, less than 992px)\n@media (max-width: 991.98px) {\n  .navDescSmall {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navDescLarge": `navDescLarge---laVJs`,
	"navDescSmall": `navDescSmall---wG5we`,
	"description": `description---SAzOh`,
	"descriptionLarge": `descriptionLarge---HcIHo`,
	"descriptionSmall": `descriptionSmall---gVpo3`
};
export default ___CSS_LOADER_EXPORT___;
